import { render } from "./packages-table.vue?vue&type=template&id=07e95246"
import script from "./packages-table.vue?vue&type=script&lang=js"
export * from "./packages-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__